module.exports = __webpack_public_path__ + "img/747A6F_292E2A_ACA79F_45453B-256px.2cc00b47.png";